<template>
  <div>
    <navbar fixed back bg>
      <span slot="title">{{title}}</span>
    </navbar>
    <div class="page-content">
      <scroller ref="scroller">
        <div class="content-padded">
          <div class="inner" style="z-index:20">
            <h1 class="characteristic-title">申请条件</h1>
            <div class="characteristic-txt">
              <p v-for="(item, index) in apply" :key="index">
                <span>{{item.title}}</span>：<span>{{item.content}}</span>
              </p>
            </div>
          </div>
          <div class="inner" style="z-index:10">
            <h1 class="inner-title"><span class="iconfont">&#xe608;</span>&nbsp;适用人群</h1>
            <ul class="counter-list">
              <li class="item" v-for="(item, index) in application" :key="index">
                <span>{{item.title}}</span>：<span>{{item.content}}</span>
              </li>
            </ul>
          </div>
          <div class="inner" style="z-index: 0">
            <h1 class="inner-title"><span class="iconfont">&#xe607;</span>&nbsp;所需材料</h1>
            <ul class="counter-list">
              <li class="item" v-for="(item, index) in material" :key="index">{{item.content}}</li>
            </ul>
          </div>
        </div>
        <div class="wrap-btn">
          <button class="apply-btn" type="button" @click="doOrder">立即申请</button>
        </div>
      </scroller>
    </div>
    <spinner :show="loading"></spinner>
  </div>
</template>

<script>
  import Navbar from 'components/navbar/navbar'
  import Scroller from 'components/scroller/scroller'
  import Spinner from 'components/spinner/spinner'

  import SetWechatTitle from '../../utils/setWechatTitle.js'

  export default {
    data () {
      return {
        loading: false,
        title: '',
        application: [],
        apply: [],
        material: []
      }
    },
    watch: {
      'title' () {
        SetWechatTitle(this.title)
      }
    },
    methods: {
      _fetchData () {
        let vm = this
        this.loading = true
        this.$ajax({
          url: '/getProductExplainByPid.jhtml',
          params: {
            productId: vm.pid
          },
          done (info) {
            vm.application = info.application
            vm.apply = info.apply
            vm.material = info.material
            vm.title = info.productName
            vm._refresh()
          },
          fail (msg) {
            vm.$dialog(msg)
          },
          always () {
            vm.loading = false
          }
        })
      },
      _refresh () {
        this.$nextTick(() => {
          if (this.$refs.scroller) {
            setTimeout(() => {
              this.$refs.scroller.resize()
            }, 500)
          }
        })
      },
      doOrder () {
        let token = this.$cache.getUserToken()
        if (!token) {
          this.$router.push('/auth/login')
        } else {
          let vm = this
          this.$ajax({
            url: '/center/isRealNameVerify.jhtml',
            params: {
              uid: token.uid
            },
            done (d, p, r) {
              if (d === 0) {
                vm.$router.push('/auth/authentication')
              } else {
                vm.$router.push(`/borrow/action/${vm.pid}`)
              }
            }
          })
        }
        // this.$router.push(`/borrow/action/${this.pid}`)
      }
    },
    components: {
      Navbar,
      Scroller,
      Spinner
    },
    mounted () {
      this.pid = this.$route.params.id
      this._fetchData()
    },
    beforeRouteEnter (to, from, next) {
      if (to.params.id) {
        next()
      } else {
        next(false)
      }
    }
  }
</script>

<style lang="stylus" rel="stylesheet/stylus" scoped>
  @import '../../common/css/mixmin'

  ul, li
    padding 0
    list-style-type none
    margin 0

  .content-padded
    padding px2rem(20) 1em px2rem(40)

    .inner
      position relative
      margin-bottom px2rem(20)
      padding px2rem(20) 1em
      line-height 1.5
      border-radius px2rem(5)
      background-color #fff
      box-shadow 0 px2rem(10) px2rem(15) rgba(171,185,197, 1)

      .characteristic-title
        margin-top 0
        margin-bottom px2rem(5)
        font-size px2rem(32)
        color #275482

      .inner-title
        margin-top 0
        margin-bottom px2rem(5)
        font-size px2rem(30)
        color #275482
        .iconfont
          color #3a80ec

      .characteristic-txt
        font-size px2rem(26)
        color #275482
        p
          margin 0
  .counter-list
    counter-reset counter
    .item
      counter-increment counter
      color #4e465a
      font-size px2rem(26px)
      line-height px2rem(48px)
      // &:before
      //   content counter(counter)
      //   display inline-block
      //   width px2rem(36)
      //   height px2rem(36)
      //   margin-right px2rem(10px)
      //   line-height px2rem(34px)
      //   color #3a80ec
      //   text-align center
      //   border-radius 50%
      //   background-color #eff6fd

  .wrap-btn
    width 80%
    margin-left 10%

    .apply-btn
      display block
      width 100%
      height px2rem(80)
      font-size px2rem(32)
      color #fff
      letter-spacing px2rem(4)
      border none
      border-radius px2rem(8)
      background-color #60c9c8
      box-shadow 0 0 px2rem(4) rgba(18,119,163, .75)

</style>



// WEBPACK FOOTER //
// detail.vue?74b4e67b